<template>
  <!--
    soon will cut to several components,
    this one is overloaded
  -->
  <div class="crop-bar">

    <SidebarSwitcher
      @input="selectType"
      :items="[
        {
          key: 'soil-grown',
          label: $ml.get(`Soil-grown`),
        },
        {
          key: 'nutrient solution',
          label: $ml.get(`Hydroponic`),
        },
      ]"
      :value="filters.type"
    />

    <div class="body">
      <div class="filters">
        <search-bar
          type="text"
          :placeholder="$ml.get(`Search`)"
          v-model="search"
          @input="updateSearch"
        />
        <!-- <SearchInput  @input="updateSearch" :secDelay="1" /> -->
      </div>

      <div class="list">
        <div class="scroller">
          <SelectorOverlayContainer
            :value="$route.params.crop"
            :react-on="crops"
            ref="overlay"
          >
            <div v-if="crops.length > 0">
              <SelectorOverlayItem
                v-for="(item, i) in crops"
                :key="item.id"
                v-if="i < 20"
              >
                <CropItem :data="item"/>
              </SelectorOverlayItem>
              <p v-if="crops.length > 20" class="bottom-text">{{$ml.get('Use search to find more crops')}}</p>
            </div>
            <p class="bottom-text" v-else>{{$ml.get('Sorry, no crops found named ')}} <b>{{search}}</b></p>
          </SelectorOverlayContainer>
        </div>
      </div>

      <!-- <AppPagination
        :start="Number(page)"

        :length="Number(pageCount)"
        :event="true"
        @pagEvent="changePage"
      /> -->
    </div>

  </div>
</template>

<script>
import API from '@/api'
import CropItem from './CropItem'
import { mapGetters } from 'vuex'
import {
  SelectorOverlayContainer,
  SelectorOverlayItem
} from '@/components/common/selector-overlay'
import SearchInput from '@/components/common/SearchInput'
import SidebarSwitcher from '@/components/common/SidebarSwitcher'
import AppPagination from '@/components/common/AppPagination'

export default {
  data() {
    return {
      search: ''
    }
  },
  created () {
    // env.API.post('/crop/select', {take: 20, page: 0, sortParam: 'name', sortDir: 'DESC'}).then(res => {
    //   console.log(res);
    // });

  },
  methods: {

    updateSearch(val) {
      this.filters.search = val;
    },
    selectType(type) {
      this.$store.commit('crop/cropbar/setType', type);
    }
  },
  computed: {
    ...mapGetters({
      filters: 'crop/cropbar/filters',
      items: 'user-crops/data',
    }),
    crops() {
      this.filters.search = this.search ? this.search : ''
      return this.items.filter(n => {
        const type_filter = n.type === this.filters.type;
        const search_filter = new RegExp(this.filters.search, 'i').test(n.name);
        return type_filter && search_filter;
      })
    }
  },
  components: {
    CropItem,
    SelectorOverlayContainer,
    SelectorOverlayItem,
    SearchInput,
    SidebarSwitcher,
    AppPagination
  }
}
</script>

<style lang="scss" scoped>

@import '@/styles/vars';

.bottom-text {
  font-size: 12px;
  text-align: center;
  opacity: .7;
  margin: 21px 0 15px;
}

.crop-bar {
  // width: 300px;
  position: relative;
  border: 1px solid #E4E5E6;
  background: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 16px;
  .body {
    display: flex;
    flex-direction: column;
    height: calc(100% - 30px);

    .filters {
      padding-bottom: 16px;
    }
  }

  .list {
    .scroller {
      height: calc(100vh - 301px);
      overflow-y: auto;
    }
  }

  .selector-overlay-item {
    border-top: 1px solid rgba(76, 80, 86, 0.10);
  }

  @media(max-width:768px) {
    min-width: 100%;
    width:100%;
  }
}

</style>
